module.exports = __webpack_public_path__ + "static/media/main.144eb476.JPG";